import React, { useState, useEffect, useContext } from 'react';
import axios from "axios";
import styled from 'styled-components';
import { useForm } from "react-hook-form";
import MediumHeading from "../components/shared/MediumHeading";
import LargeHeading from "../components/shared/LargeHeading";
import Paragraph from "../components/shared/Paragraph";
import Button from "../components/shared/Button";
import Footer from "../components/shared/Footer";
import MyGoogleMap from '../components/Contact/MyGoogleMap';
import { KeywordsContext } from '../contexts/KeywordsProvider';

const renderHTML = rawHTML => React.createElement("span", { dangerouslySetInnerHTML: { __html: rawHTML } });

const Contact = () => {
  const [page, setPage] = useState({});
  const keywords = useContext(KeywordsContext);

  useEffect(() => {
    axios
      .get(`https://www.paralele.me/api/contact/index.php?lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        setPage(data);
      })
  }, []);

  const [isFormSending, setIsFormSending] = useState(false);
  const [formSent, setFormSent] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = data => {
    setIsFormSending(true);
    axios
      .post(`https://www.paralele.me/api/contact/send.php`, data)
      .then(res => {
        setIsFormSending(false);
        if (res.data.status === 'SUCCESS') {
          setFormSent(true);
        } else {
          alert('Error in sending');
        }
      })
      .catch(err => {
        setIsFormSending(false);
        console.error(err)
      });
  }

  return (
    <>
      <div className="container text-center">
        <div className='row'>
          <div className='col-lg-6 mb-5'>
            <MediumHeading>{page.description}</MediumHeading>
            <Paragraph>
              {renderHTML(page.text)}
            </Paragraph>

            <LargeHeading className="mt-4">{window.keywords.sendMessage}</LargeHeading>
            {formSent ? <p>{window.keywords.formSend}</p> : (
              <FormStyled onSubmit={handleSubmit(onSubmit)} className="mt-4">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <Input
                      name="name"
                      className={errors?.name && "is-invalid"}
                      placeholder={window.keywords.fullName}
                      ref={register({ required: true })}
                    />
                    {errors.name &&
                      <div className="invalid-feedback text-left">
                        {window.keywords.requiredField}
                      </div>
                    }
                  </div>
                  <div className="form-group col-md-6">
                    <Input
                      name="email"
                      className={errors.email && "is-invalid"}
                      placeholder="Email"
                      ref={register({
                        required: window.keywords.requiredField,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: window.keywords.enterCorrectEmail
                        }
                      })}
                    />
                    {errors.email &&
                      <div className="invalid-feedback text-left">
                        {errors.email.message}
                      </div>
                    }
                  </div>
                </div>
                <div className="form-row mb-5">
                  <div className="form-group col-12">
                    <Textarea
                      type="email"
                      name="message"
                      className={errors.message && "is-invalid"}
                      placeholder={window.keywords.message}
                      ref={register({ required: true })}
                    />
                    {errors.message &&
                      <div className="invalid-feedback text-left">
                        {window.keywords.requiredField}
                      </div>
                    }
                  </div>
                </div>
                <Button 
                  type="submit" 
                  disabled={isFormSending} 
                  text={isFormSending ? window.keywords.sendBtnSending : window.keywords.sendBtnMessage} 
                />
              </FormStyled>
            )}
          </div>
          <div className='col-lg-6'>
            <MyGoogleMap center={{
              lat: parseFloat(keywords.locationLat),
              lng: parseFloat(keywords.locationLng)
            }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

const FormStyled = styled.form`
  max-width: 630px;
  margin-left: auto;
  margin-right: auto;
`

const Input = styled.input`
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  padding: 12px;

  &:focus {
    outline: none;
  }
`

const Textarea = styled.textarea`
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  padding: 12px;

  &:focus {
    outline: none;
  }
`

export default Contact;